import axios from 'axios'
import { BUSCAR_ITINERARIOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';
import { salvarCacheItinerarios, carregarCacheItinerarios } from '../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarItinerarios (codigo, codigoRota, pagina, registrosPorPagina, filtros) {
  if (!codigoRota) {
    codigoRota = 0;
  }

  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/itinerario/empresa/${codigo}/rota/${codigoRota}/itinerarios/${urlFiltros}`;
  const hoje = new Date().toISOString().split('T')[0];

  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheItinerarios(codigo, hoje, response.data);
      return dispatch({ type: BUSCAR_ITINERARIOS, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || (erro.code && erro.code === 'ECONNABORTED') || !erro.response) {
        const cache = carregarCacheItinerarios(codigo, hoje);
        if (cache) {
          return dispatch({ type: BUSCAR_ITINERARIOS, payload: { data: cache } });
        }
      }
      throw erro;
    });
}
